export const getParsedResultsMetric = results => {
  if (typeof results === 'string' && results.length > 0) {
    return parseStringToObject(results)
  } else {
    return { name: '', value: '' }
  }
}

export function parseStringToObject(string) {
  try {
    // Replace single quotes with double quotes to make it a valid JSON string
    const correctedString = string.replace(/'/g, '"')
    // Parse the corrected string into a regular JavaScript object
    const parsedObject = JSON.parse(correctedString)
    return parsedObject
  } catch (error) {
    console.error('Failed to parse the string into an object:', error, string)
    return {}
  }
}

export const calculateCPA = (spend, conversion) => {
  if (spend > 0 && conversion > 0) {
    return spend / conversion
  } else {
    return 0
  }
}
